module.exports = "/images/terms_of_service_hero.svg?24123620c3d1c4007851ce3a608f605f";